import { SUBMOTIVE4_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useSubmotive4ListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SUBMOTIVE4_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
